'use client';

import MediaView from "@/app/features/shared/media-view/ui/public/MediaView.public";
import { useHomeEditor } from "@/app/features/sites/home/contexts/HomeContext";
import { MediaRef } from "@/app/features/shared/__to_be_integrated/types/general/media/media";
import { mediaRefUrl } from "@/app/features/shared/__to_be_integrated/types/general/media/media-helper";

import { memo, useCallback } from "react";
import { HomeHeroFrame } from "@/app/features/sites/home/ui/shared/HomeViewFrames";
import styles from "./home-editable.module.css";
import clsx from "clsx";
import EditableTypographyV2 from "@/app/features/shared/editable-typography/EditableTypographyV2";
import { PLACEHOLDER_IMAGE } from "@/app/types/common/constants";

const heroMediaSlots = {
    root: { className: 'home-hero-image flex flex-auto size-full z-0' },
    image: {
        style: {
            objectFit: 'cover' as const,
        },
        quality: 75,
        priority: true,
        fetchPriority: 'high' as const,
        loading: 'eager' as const,
        sizes: '100vw',
    },
};

const HeroBackgroundMedia = memo(
    function HeroBackgroundMedia({
        src,
    }: {
        src: MediaRef;
    }) {
        return (
            <MediaView
                src={src}
                fill
                showLoadingSpinner={false}
                slots={heroMediaSlots}
            />
        );
    },
    (prev, next) => mediaRefUrl(prev.src) === mediaRefUrl(next.src)
);

export default function HomeHero() {
    const { editable, updateEditable } = useHomeEditor();

    const updateTitle = useCallback((title: string) => {
        updateEditable({ title });
    }, [updateEditable]);

    return (
        <HomeHeroFrame
            backgroundImage={
                <HeroBackgroundMedia
                    src={editable?.image || PLACEHOLDER_IMAGE}
                />
            }
            title={
                <EditableTypographyV2
                    variant="h1"
                    value={editable?.title || ''}
                    onChange={updateTitle}
                    slots={{
                        positioner: { className: styles.homeEditableTitlePositioner },
                        root: {
                            className: clsx(
                                'signature-border-radius glass-effect',
                                styles.homeEditableTitleBox,
                            ),
                        },
                    }}
                />
            }
        />
    )
}
